import React from 'react';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import PosIcon from '@material-ui/icons/Apps';

import { CreateButton } from 'react-admin';

const PosEmpty = ({ basePath, resource }) => (
  <Box textAlign="center" m={1}>
    <PosIcon style={{ fontSize: 140 }} />
    <Typography variant="h4" paragraph>
      No POS terminal available yet.
    </Typography>
    <Typography variant="body1">Do you want to add one?</Typography>
    <CreateButton className="primary" basePath={basePath} />
  </Box>
);

export default PosEmpty;
